import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { SEOHead, BreadcrumbSchema } from "@/components/SEOHead";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead title="Terms of Service | OnwardFlighTickets" description="Terms and conditions for using OnwardFlighTickets services." path="/terms" />
      <BreadcrumbSchema items={[{ name: "Home", url: "https://onwardflightickets.com" }, { name: "Terms of Service", url: "https://onwardflightickets.com/terms" }]} />
      <Header />
      <main className="max-w-3xl mx-auto px-4 py-16" data-testid="terms-page">
        <h1 className="font-['Outfit'] text-3xl font-bold text-[#1e293b] mb-8">Terms of Service</h1>
        <div className="prose prose-sm max-w-none text-[#475569] space-y-6">
          <section>
            <h2 className="font-['Outfit'] text-lg font-semibold text-[#1e293b]">1. Service Description</h2>
            <p>OnwardFlighTickets provides temporary flight reservation documents for travel documentation purposes, including visa applications and immigration requirements. Our reservations contain real flight data and verifiable booking references.</p>
          </section>
          <section>
            <h2 className="font-['Outfit'] text-lg font-semibold text-[#1e293b]">2. Reservation Validity</h2>
            <p>Flight reservations are valid for the selected period (48 hours, 7 days, or 14 days) from the time of purchase. Once expired, the reservation is no longer valid and cannot be renewed.</p>
          </section>
          <section>
            <h2 className="font-['Outfit'] text-lg font-semibold text-[#1e293b]">3. Refund Policy</h2>
            <p>We offer a full refund if the reservation fails to generate or if the service is unavailable. Refund requests must be made within 24 hours of purchase.</p>
          </section>
          <section>
            <h2 className="font-['Outfit'] text-lg font-semibold text-[#1e293b]">4. Limitation of Liability</h2>
            <p>OnwardFlighTickets provides reservation documents only. We are not an airline or travel agency. We are not responsible for immigration decisions made by authorities.</p>
          </section>
          <section>
            <h2 className="font-['Outfit'] text-lg font-semibold text-[#1e293b]">5. Contact</h2>
            <p>For questions about these terms, please contact us at support@onwardflightickets.com.</p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
